
import { bool, nullable, object, oneOfType } from 'vue-types';
export default {
  props: {
    featured: bool().def(true),
    card: oneOfType([object(), nullable()]),
  },
};
